import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import api from '../../../../../api.js';
import conf from '../../../../../shared/conf.js';

import Rating from '../../../Rating/Rating.jsx';

import './Review.scss';

class Review extends Component {
  static propTypes = {
    title: PropTypes.bool,
  };

  static defaultProps = {
    title: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      reviews: this.formatReview(this.props?.reviews ?? null, this.props?.human_skills ?? null),
    }
  }

  componentDidMount() {
    if (!this.props.reviews) {
      this.loadReviews(this.props.freelance);
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.freelance.id !== prevProps.freelance.id && !this.props.reviews) {
      this.loadReviews(this.props.freelance);
    }
  }

  loadReviews = async (freelance) => {
    try {
      const [reviewResponse, humanSkillsResponse] = await Promise.all([
        api.freelances.reviews.getAll({
          freelance: freelance.id,
        }),
        api.skills.humans.getAll()
      ]);

      if (reviewResponse.data.reviews.length > 0) {
        const reviews = reviewResponse.data.reviews[0];
        const human_skills = humanSkillsResponse.data.filter(skill => skill.account_type === conf.accountTypes.do);

        this.setState({
          reviews: this.formatReview(reviews, human_skills)
        });
      } else {
        this.setState({reviews: null});
      }
    } catch (e) {
      console.warn(e);
    }
  };

  formatReview = (reviews, human_skills) => {
    if (!human_skills) {
      human_skills = [];
    }

    if (!reviews) {
      return reviews;
    }

    reviews.human_skills
      .map((item) => {
        if (item.skill) {
          item.id = item.skill.id;
          item.name = item.skill.name;
        }

        for (let i = 0; i < human_skills.length; i++) {
          if (human_skills[i].id === item.id) {
            item.description = human_skills[i].description;
          }
        }

        return item;
      })
      .filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj['id']).indexOf(obj['id']) === pos;
      })
    ;

    reviews.skills
      .map((item) => {
        if (item.skill) {
          item.id = item.skill.id;
          item.name = item.skill.name;
          item.description = item.skill.description;
        }

        return item;
      })
      .filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj['id']).indexOf(obj['id']) === pos;
      })
    ;

    reviews.skills.sort((a, b) => {
      if (a.rate > b.rate) {
        return -1;
      } else if (a.rate < b.rate) {
        return 1;
      } else {
        return 0;
      }
    });

    return reviews;
  };

  render() {
    if (!this.state.reviews) {
      return null;
    }
    return (
      <div className={`row ${this.props.className}`}>
        <div className="col-md-12">
          <div className="review">
            <h3 className="sub-title">Principales expertises</h3>
            <div className="row px-3 pt-3 review-item">
              <div className="col-lg-9 col-md-12 human-skills">
                {this.state.reviews.global_rating || this.state.reviews.human_skills.length > 0 ?
                  <div className="no-print">
                    {this.props.title ? <h4>Expertises métiers</h4> : ''}
                    <div className="pr-md-2 pb-md-2 pl-md-2">
                      {this.state.reviews.global_rating ?
                        <Rating
                          label="Séniorité globale :"
                          align={true}
                          value={this.state.reviews.global_rating}
                        /> : ''
                      }
                      {this.state.reviews.human_skills.map((skill) => (
                        <Rating
                          align={true}
                          value={skill.rate}
                          key={skill.id}
                          label={`${skill.name} :`}
                        />
                      ))}
                    </div>
                  </div>
                  : ''
                }
                {this.state.reviews.skills.length > 0 ?
                  <div>
                    {this.props.title ? <h4 className="no-print">Spécialités</h4> : <div className="separator"/>}
                    <div className="pr-md-2 pb-md-2 pl-md-2">
                      {this.state.reviews.skills.map((skill) => (
                        <Rating
                          align={true}
                          value={skill.rate}
                          key={skill.id}
                          label={`${skill.name} :`}
                        />
                      ))}
                    </div>
                  </div>
                  : ''
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    currentUser: state.currentUser.user
  })
)(Review);